/* eslint-disable react/default-props-match-prop-types */
// import { ChangeEventHandler } from "react";
import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { ToggleSwitch } from '@tmsw/powerups.ui.form.toggle-switch';
import './A11yMenu.css';

export type A11yMenuProps = {
  onChangeCaptions: (nativeEvent: any) => void;
  onChangeDescriptions: (nativeEvent: any) => void;
};

export function A11yMenu({
  onChangeCaptions,
  onChangeDescriptions,
}: A11yMenuProps) {
  const { __t } = useTranslation();
  const captionsEnabled = useStore((state) => state.captionsEnabled);
  const descriptionsEnabled = useStore((state) => state.descriptionsEnabled);
  const setCaptionsEnabled = useStore((state) => state.setCaptionsEnabled);
  const setDescriptionsEnabled = useStore(
    (state) => state.setDescriptionsEnabled
  );
  const localeConfig = __t('VIE');
  const a11yMenuConfig = __t('A11Y_MENU');

  return (
    <section className="SettingsPanel-Container" id="A11y-Menu" key="a11y_menu">
      <h1>{a11yMenuConfig.header}</h1>
      <h2>{a11yMenuConfig.subHeader1}</h2>
      <p>{a11yMenuConfig.bodyCopy1}</p>
      <ToggleSwitch
        onChange={(evt) => {
          const { nativeEvent } = evt;
          setDescriptionsEnabled(evt.target.checked);
          return onChangeDescriptions(nativeEvent);
        }}
        checked={descriptionsEnabled}
        aria-label={
          descriptionsEnabled
            ? a11yMenuConfig.descriptionsToggle.on.label
            : a11yMenuConfig.descriptionsToggle.off.label
        }
        tabIndex={0}
      >
        {localeConfig.ENABLE_AUDIO_DESCRIPTIONS}
      </ToggleSwitch>

      <h2>{a11yMenuConfig.subHeader2}</h2>
      <p>{a11yMenuConfig.bodyCopy2}</p>

      <ToggleSwitch
        onChange={(evt) => {
          const { nativeEvent } = evt;
          setCaptionsEnabled(evt.target.checked);
          return onChangeCaptions(nativeEvent);
        }}
        checked={captionsEnabled}
        aria-label={
          captionsEnabled
            ? a11yMenuConfig.captionsToggle.on.label
            : a11yMenuConfig.captionsToggle.off.label
        }
        tabIndex={0}
      >
        {localeConfig.ENABLE_CAPTIONS}
      </ToggleSwitch>

      <h2>{a11yMenuConfig.subHeader3}</h2>
      <p>{a11yMenuConfig.bodyCopy3}</p>

      <h2>{a11yMenuConfig.subHeader4}</h2>
      <p>{a11yMenuConfig.bodyCopy4}</p>
      <p>{a11yMenuConfig.bodyCopy5}</p>
    </section>
  );
}

A11yMenu.defaultProps = {
  onChangeCaptions: () => {},
  onChangeDescriptions: () => {},
};
